export default async function decodeURL(input) {
  return decodeURI(input)
}
